import React from 'react';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { Modal } from '@beef/ui-kit';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { getModalVisibilityFlag } from "../../../../store/blocks/devices/modalSelectors";
import { closeDeviceModal } from "../../../../store/blocks/devices/slice";
import styles from "./styles.pcss";
var cx = classNames.bind(styles);
export var _DeviceInfoPopup = function _DeviceInfoPopup(_ref) {
  var children = _ref.children,
    isOpen = _ref.isOpen,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    onClose: onClick,
    "data-t-id": "components-DeviceInfoPopup"
  }, /*#__PURE__*/React.createElement("div", {
    className: cx('container'),
    "data-t-id": "components-DeviceInfoPopup"
  }, children));
};
_DeviceInfoPopup.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClick: PropTypes.func
} : {};
var mapStateToProps = function mapStateToProps(state) {
  var openStatus = getModalVisibilityFlag(state);
  return {
    isOpen: openStatus,
    shouldRender: openStatus
  };
};
var mapDispatchToProps = {
  onClick: closeDeviceModal
};
export var DeviceInfoPopup = compose(connect(mapStateToProps, mapDispatchToProps), withRenderFlag)(_DeviceInfoPopup);